export const utilsTypeof = {

    isValidNumber: (value: unknown): value is number => {
        return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
    },
    isValidString: (value: unknown): value is string => {
        return typeof value === 'string' || value instanceof String
    },
    isObject: (value: unknown): value is object => {
        return (
            typeof value === "object" &&
            value !== null &&
            !Array.isArray(value)
        );
    },
    isArray: (value: unknown): value is [] => {
        return Array.isArray(value);
    }
}